import { Component, Prop, h, Host } from '@stencil/core';
import * as colors from 'pn-design-assets/pn-assets/colors.js';
import type { PnColors } from '@/index';

/**
 * The `pn-icon` is a wrapper for an SVG string.
 * While its built with PostNords specific icon dimensions in mind (24x24px), you can use any SVG content in this component.
 * As long as its 3x3 in size, there should be no problem.
 *
 * The color feature looks for any `black` and `#000` values and replaces it with the value from `color`.
 * If you use flags from pn-design-assets, the color feature will not overwrite the flags color.
 **/
@Component({
  tag: 'pn-icon',
  styleUrl: 'pn-icon.scss',
})
export class PnIcon {
  /**
   * The SVG content of the icon you want to use.
   *
   * Flags cannot be colored.
   *
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-design-tokens-icon--docs|PostNord Icons (Storybook)}
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-design-tokens-flag--docs|PostNord Flags (Storybook)}
   **/
  @Prop() icon: string = '';
  /** Make the icon small (16 instead of 24px). */
  @Prop() small: boolean = false;
  /**
   * Color the icon with one of the follwing colors from our library.
   * @see {@link https://portal.postnord.com/web-components/?path=/docs/components-design-tokens-colors--docs|PostNord Colors (Storybook)}
   **/
  @Prop() color?: PnColors = 'gray900';

  getIcon() {
    if (/pn-icon-flag/.test(this.icon)) return this.icon;
    // The replace is just setting the fill attribute on the SVG to the color passed to the component
    return this.icon.replace(/(black|#000)/g, colors[this.color]);
  }

  render() {
    return <Host role="presentation" class={`pn-icon ${this.small ? 'small' : ''}`} innerHTML={this.getIcon()}></Host>;
  }
}
